import axios from '@/api/axios'

const createSheltersMap = (sheltersMap) => {
  return axios.put('/sheltersMap', sheltersMap)
}

const deleteSheltersMap = (id) => {
  return axios.delete(`/sheltersMap/${id}`)
}

const getSheltersMapByParams = () => {
  return axios.get(`/sheltersMap/list`).then((response) => response.data)
}

export default {
  createSheltersMap,
  getSheltersMapByParams,
  deleteSheltersMap,
}
